//
//
//
//
//
//
//
//
//

let timer = null;
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: '下一步'
        }
    },
    data() {
        return {
            position: ''
        }
    },
    mounted() {
        document.addEventListener('scroll', this.setFixed)
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.setFixed)
    },
    methods: {
        /**
         * @method setFixed 判断滾動條高度到達底部時，導航position設置為relative(置底)
         */
        setFixed() {
            if(timer) clearTimeout(timer)
            timer = setTimeout(()=>{
                let { scrollHeight, clientHeight } = document.documentElement,
                    _nextHeight = this.$refs.next.offsetHeight,
                    scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;                    
                if(scrollHeight - scrollTop <= clientHeight + _nextHeight * 3) this.position = 'relative'
                else this.position = 'fixed'
            }, 100)
        },
        next() {
            this.$emit('next')
        }
    }
}
